<template>
  <v-layout wrap>
    <v-flex xs12>
      <h1>{{ title }}</h1>
    </v-flex>
    <v-flex xs12 sm6>
      <v-text-field
        v-model="editedItem.emergencyFirstName"
        label="First Name"
        :rules="nameRules"
        :counter="50"
        required
        :dark="dark"
        @blur="sendDataToParent"
      ></v-text-field>
    </v-flex>
    <v-flex xs12 sm6>
      <v-text-field
        v-model="editedItem.emergencyLastname"
        label="Last Name"
        :rules="nameRules"
        :counter="50"
        required
        :dark="dark"
        @blur="sendDataToParent"
      ></v-text-field>
    </v-flex>
    <v-flex xs12 sm6>
      <v-text-field
        v-model="editedItem.emergencyPhone"
        label="Phone"
        type="number"
        :rules="phoneRules"
        required
        :dark="dark"
        @blur="sendDataToParent"
      ></v-text-field>
    </v-flex>
    <v-flex xs12 sm6>
      <v-text-field
        v-model="editedItem.emergencyAthleteRelationship"
        label="Relationship to athlete "
        required
        :dark="dark"
        @blur="sendDataToParent"
      ></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    value: Object,
    dark: Boolean,
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      page: 1,
      itemsPerPage: 10,
      pageCount: 0,
      tab: "Novice",
      isFormValid: true,
      status: "active",
      search: "",
      loadingTable: true,
      dialog: false,
      menu: false,
      name: "Default",
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length <= 50) || "Name must be less than 10 characters"
      ],
      requiredRule: [v => !!v || "Value is required"],
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v =>
                /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || // eslint-disable-line
          "E-mail must be valid"
      ],
      phoneRules: [
        v => !!v || "Phone number is required",
        v =>
          /^\+?\d{1,3}[-\s]?\(?\d{3}\)?[-\s]?\d{3}[-\s]?\d{4}$/.test(v) ||
          "Phone number must be valid"
      ],
      editedIndex: -1,
      editedItem: {
        emergencyFirstName: "",
        emergencyLastname: "",
        emergencyPhone: "",
        emergencyAthleteRelationship: ""
      }
    };
  },
  methods: {
    sendDataToParent() {
      this.$emit("input", this.editedItem);
    }
  }
};
</script>

<!--style module>
      
       body {
         height: auto;
         width: auto;
         margin: auto;
         overflow: scroll;
      }
      @media print {
        body { 
          overflow: auto;
          height: auto; 
        }
      }
      
      </style-->
